let currentBrand: string | null = null

export const setBrand = (brand: string): void => {
    currentBrand = brand
}

export const getBrand = (): string => {
    if (currentBrand === null) {
        console.warn('[currentBrand] Brand requested before it was set, falling back to "audi"')

        return 'audi'
    }

    return currentBrand
}
